module.exports = __webpack_public_path__ + "static/img/hp.9843efe5.png";